"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextToSpeechInputFromAvatarInput = void 0;
/**
 * Get TextToSpeechInput from AvatarInput.
 * Leaves only the fields that are relevant for text-to-speech.
 * @param avatarInput
 */
const getTextToSpeechInputFromAvatarInput = (avatarInput) => {
    return {
        narrator: avatarInput.narrator,
        text: avatarInput.text,
        rate: avatarInput.rate,
        volume: avatarInput.volume
    };
};
exports.getTextToSpeechInputFromAvatarInput = getTextToSpeechInputFromAvatarInput;
//# sourceMappingURL=providerTypes.js.map